<div class="wizard-modal">
  <h2 class="wizard-title">Account Cleanup Wizard</h2>

  <div class="wizard-info">
    <p>This wizard will assist you in updating your account</p>
    <p class="wizard-info-tier">From {{ oldTierName }} to {{ newTierName }}</p>
  </div>

  <div class="wizard-info">
    <p>{{ newTierName }} subscription allows for {{ maxMaps }} maps</p>
    <p>{{ newTierName }} subscription allows for {{ maxGames }} game(s)</p>
    <p>{{ newTierName }} subscription allows for {{ maxCharacters }} character(s)</p>
  </div>

  <div class="wizard-stats">
    <div class="wizard-stat">
      <span class="wizard-stat-label">Maps</span>
      <span class="wizard-stat-value" [class.wizard-stat-value--over]="isMapsOverLimit()">{{ currentMaps }}</span>
    </div>
    <div class="wizard-stat">
      <span class="wizard-stat-label">Games</span>
      <span class="wizard-stat-value" [class.wizard-stat-value--over]="isGamesOverLimit()">{{ currentGames }}</span>
    </div>
    <div class="wizard-stat">
      <span class="wizard-stat-label">Characters</span>
      <span class="wizard-stat-value" [class.wizard-stat-value--over]="isCharactersOverLimit()">{{ currentCharacters }}</span>
    </div>
  </div>

  <div class="wizard-actions">
    @if (!downgradeResponse?.cleanup_required) {
      <button type="button" class="btn btn-outline" (click)="close()">Cancel</button>
    }
    <button type="button" class="btn btn-theme" (click)="proceed()">Proceed</button>
  </div>
</div>
